<template>
    <div id="app" class="container mt-5">
        <h2 class="border-bottom pb-2 mb-4">Pivot
            <small>(drag & drop UI + PivotTable)</small>
        </h2>
        <div class="col-md-3" style="padding-left: 0; margin-bottom: 20px;">
            <h4 v-if="error" class="text-danger text-error" style="padding-right: 0.35rem;">{{ this.error }}</h4>
            <div class="row">
                <div class="col-md-9" style="padding-right: 0;">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="reducerData" placeholder="Value for Reducer" >
                        <i class="fa fa-times reset" aria-hidden="true" @click="reset"></i>
                    </div>
                </div>
                <div class="col-md-3">
                    <a class="btn btn-icon btn-2 btn-success" @click="go">
                        <span class="btn-inner--icon"><i class="ni ni-atom"></i></span>
                    </a>
                </div>
            </div>

        </div>
        <div class="mb-5" v-if="isData">
            <pivot
                    :data="rData"
                    :fields="fields"
                    :row-fields="rowFields"
                    :col-fields="colFields"
                    :reducer="reducer"
                    :default-show-settings="defaultShowSettings"
            >
                <template slot="value" slot-scope="{ value }">
                    {{ value  }}
                </template>
                <template slot="genderHeader" slot-scope="{ value }">
                    <svg v-if="value == 'female'" aria-hidden="true" data-prefix="fas" data-icon="venus" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" class="svg-inline--fa fa-venus fa-fw">
                        <path fill="currentColor"
                              d="M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                              class=""></path>
                    </svg>
                    <svg v-else-if="value == 'male'" aria-hidden="true" data-prefix="fas" data-icon="mars" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-mars fa-fw">
                        <path fill="currentColor"
                              d="M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                              class=""></path>
                    </svg>
                    {{ value | capitalize }}
                </template>
            </pivot>
        </div>

        <h2 class="border-bottom pb-2 mb-4">PivotTable
            <small>(standalone)</small>
        </h2>

        <div class="mb-5" v-if="isData">
            <pivot-table
                    :data="asyncData"
                    :row-fields="fields"
                    :col-fields="colFields"
                    :reducer="reducer"
                    :default-show-settings="defaultShowSettings"
                    :is-data-loading="isDataLoading"
            >
                <template slot="value" slot-scope="{ value }">
                    {{ value | number }}
                </template>
                <template slot="genderHeader" slot-scope="{ value }">
                    <svg v-if="value == 'female'" aria-hidden="true" data-prefix="fas" data-icon="venus" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" class="svg-inline--fa fa-venus fa-fw">
                        <path fill="currentColor"
                              d="M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                              class=""></path>
                    </svg>
                    <svg v-else-if="value == 'male'" aria-hidden="true" data-prefix="fas" data-icon="mars" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-mars fa-fw">
                        <path fill="currentColor"
                              d="M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                              class=""></path>
                    </svg>
                    {{ value | capitalize }}
                </template>
                <template slot="loading">
                    <div class="text-center">
                        <svg aria-hidden="true" data-prefix="fas" data-icon="spinner" role="img"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                             class="svg-inline--fa fa-spinner fa-fw fa-pulse">
                            <path fill="currentColor"
                                  d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                                  class=""></path>
                        </svg>
                        Loading...
                    </div>
                </template>
            </pivot-table>
        </div>
    </div>
</template>

<script>
import Pivot from './Pivot'
import PivotTable from './PivotTable'
export default {
    name: 'pivot-all',
    components: { Pivot, PivotTable },
    props: [
        'rData'
    ],
    data: () => {
        return {
            data: this.rData,
            asyncData: [],
            fields: [],
            reducerData: null,
            rowFields: [],
            colFields: [],
            error: null,
            isData: false,
            reducer: null,
            defaultShowSettings: true,
            isDataLoading: false
        }
    },
    mounted () {
        this.reducerData = localStorage.getItem('reducerData')
        this.fields = localStorage.getItem('fields')
        this.fields = JSON.parse(this.fields)
        this.reducer = localStorage.getItem('reducer')
        this.go()
    },
    created: function() {
        this.isDataLoading = true
        setTimeout(() => {
            this.asyncData = this.rData
            this.isDataLoading = false
        }, 3000)
    },
    methods: {
        go () {
           /*this.rData.map(n => {
               let countSubsrt = (this.reducerData.length - 1) - 25
               let nameOfValue =this.reducerData.substr(26, countSubsrt)
                if (typeof n[nameOfValue] !== 'number') {
                    this.error = 'Value must be numeric: item[Numeric]'
                } else {
                    this.error = null
                }
            })*/
            if (!this.error) {
                  this.isData = true
                  this.getData()
            }
        },
        reset () {
            this.isData = false
            this.rowFields = []
            this.reducer = null
            this.reducerData = null
            this.error = null
        },
        getData () {
            this.fields = []
            this.reducer = null
            let obj = {}
            this.rData.map((d, k) => {
                obj = Object.keys(d)
            })
            obj.map(w => {
                let nameForSecondValue = this.reducerData.substr(20,((this.reducerData.length) - 3) - 21)
                let countSubsrt = (this.reducerData.length - 1) - 25
                let nameOfValue =this.reducerData.substr(26, countSubsrt)
                if (w !== nameOfValue) {
                  this.fields.push({
                    getter: item => item[w],
                    label: w.charAt(0).toUpperCase() + w.substr(1),
                  })
                  localStorage.setItem('fields', JSON.stringify(this.fields))
                }
                localStorage.setItem('reducerData', this.reducerData)
                this.rData.map(n => {
                   if (typeof n[nameOfValue] === 'number') {
                       this.reducer = (sum, item) => sum + item[nameOfValue]
                   } else if (this.reducerData === '(sum, item) => sum + 1') {
                       this.reducer = (sum, item) => sum + 1
                   } else if (this.reducerData === `(sum, item) => item.${nameForSecondValue} + 1`) {
                       this.reducer = (sum, item) => item[nameForSecondValue] + 1
                   }
                   localStorage.setItem('reducer', this.reducer)
                })
            })/*(sum, item) => sum + item.salary*/
        }
    },
    filters: {
        number: function(value) {
            return value.toLocaleString()
        },
        capitalize: function(value) {
            return value.replace(/\b\w/g, l => l.toUpperCase())
        }
    }
}


</script>
<style scoped>
    .text-error {
        padding-left: 0 !important;
    }
    .reset {
        position: absolute;
        top: 1px;
        right: 5px;
        font-size: 15px;
        color: #8898aa61;
    }
    .reset:hover {
        color: rgba(39, 39, 53, 0.79);
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/PivotGrid/PivotAll.vue